export type DocumentTemplateFileFetchedAction = {
	type: 'DOCUMENT_TEMPLATE_FILE_FETCHED';
	payload: { templateVersionId: number; bytes: Uint8Array };
};

export default (payload: {
	templateVersionId: number;
	bytes: Uint8Array;
}): DocumentTemplateFileFetchedAction => ({
	type: 'DOCUMENT_TEMPLATE_FILE_FETCHED',
	payload,
});
